var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonelist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 484.849 484.849",
    style: {
      enableBackground: "new 0 0 484.849 484.849"
    },
    xmlSpace: "preserve",
    fill: "#8F8F8F",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 294.924,
    cy: 194.924,
    r: 44.138
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.924,334.062c0-44.183-35.817-80-80-80c-44.183,0-80,35.817-80,80H374.924z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.924,0v113.712h-22.5v30h22.5v83.712h-25v30h25v83.712h-25v30h25v113.712h410V0H49.924z M79.924,371.136h25v-30h-25 v-83.712h25v-30h-25v-83.712h25v-30h-25V30h50v424.849h-50V371.136z M429.924,454.849h-270V30h270V454.849z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonelist);
export default __webpack_public_path__ + "static/media/phonelist.e8ff8af102f5e988ec6caeb6d4024c0a.svg";
export { ForwardRef as ReactComponent };